"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrivacyHero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: subheadlineRef,
    isVisible: subheadlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="privacy-hero" className="relative w-full min-h-[60vh] flex items-center justify-center bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541246/img/privacy_hero_background.png)]">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40" />

      {}
      <div className="relative z-10 max-w-4xl mx-auto px-6 py-16 text-center">
        <h1 ref={headlineRef} className={`text-white font-display font-bold text-5xl lg:text-6xl mb-4 transition-all duration-[var(--duration-medium)] ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          Privacy Policy
        </h1>
        <p ref={subheadlineRef} className={`text-white/90 text-lg lg:text-xl font-sans max-w-2xl mx-auto transition-all duration-[var(--duration-medium)] delay-100 ${subheadlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          Your trust and privacy matter to us. Learn how we protect your information and uphold your confidentiality.
        </p>
      </div>
    </section>;
}